(() => {
  const initialise = (root) => {
    root.querySelectorAll('[data-category-drawer]').forEach((drawer) => {
      if (drawer.dataset.categoryReady) return;
      const box = drawer.closest('#CategoryBox');
      const trigger = box?.querySelector('[data-category-open]');
      const overlay = box?.querySelector('[data-category-overlay]');
      const closeButton = drawer.querySelector('[data-category-close]');
      if (!trigger || !overlay || !closeButton) return;
      drawer.dataset.categoryReady = 'true';
      const panels = Array.from(drawer.querySelectorAll('[data-category-panel]'));
      const nextButtons = Array.from(drawer.querySelectorAll('[data-category-next]'));
      const panelFor = (id) => panels.find((panel) => panel.id === id);
      const markCurrent = (panel) => panels.forEach((item) => item.classList.toggle('is-current', item === panel));
      const hideFrom = (level) => {
        panels.forEach((panel) => {
          if (Number(panel.dataset.categoryLevel) >= level) panel.hidden = true;
        });
        nextButtons.forEach((button) => {
          if (Number(panelFor(button.dataset.categoryNext).dataset.categoryLevel) >= level) button.setAttribute('aria-expanded', 'false');
        });
      };
      const showNext = (button, focus = false) => {
        const panel = panelFor(button.dataset.categoryNext);
        const wasOpen = !panel.hidden;
        hideFrom(Number(panel.dataset.categoryLevel));
        if (wasOpen && !focus) {
          markCurrent(panelFor(panel.dataset.categoryParent));
          return;
        }
        panel.hidden = false;
        button.setAttribute('aria-expanded', 'true');
        markCurrent(panel);
        if (focus) Array.from(panel.querySelectorAll('a[href], button')).find((element) => element.getClientRects().length > 0)?.focus();
      };
      const back = (panel) => {
        const parent = panelFor(panel.dataset.categoryParent);
        hideFrom(Number(panel.dataset.categoryLevel));
        markCurrent(parent);
        nextButtons.find((button) => button.dataset.categoryNext === panel.id)?.focus();
      };
      const close = () => {
        drawer.hidden = true;
        overlay.hidden = true;
        overlay.classList.remove('overlay_active');
        document.body.classList.remove('menuslide_active', 'category-accordion-open');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      };
      trigger.addEventListener('click', () => {
        if (!drawer.hidden) {
          close();
          return;
        }
        drawer.hidden = false;
        overlay.hidden = false;
        overlay.classList.add('overlay_active');
        document.body.classList.add('menuslide_active', 'category-accordion-open');
        trigger.setAttribute('aria-expanded', 'true');
        closeButton.focus();
      });
      nextButtons.forEach((button) => button.addEventListener('click', () => showNext(button)));
      drawer.querySelectorAll('[data-category-back]').forEach((button) => button.addEventListener('click', () => back(button.closest('[data-category-panel]'))));
      closeButton.addEventListener('click', close);
      overlay.addEventListener('click', close);
      drawer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
          return;
        }
        const next = event.target.closest('[data-category-next]');
        if (event.key === 'ArrowRight' && next) {
          event.preventDefault();
          showNext(next, true);
          return;
        }
        const currentPanel = event.target.closest('[data-category-panel]');
        if (event.key === 'ArrowLeft' && currentPanel?.dataset.categoryParent) {
          event.preventDefault();
          back(currentPanel);
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = Array.from(drawer.querySelectorAll('button, a[href], [tabindex="0"]')).filter((element) => element.getClientRects().length > 0);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  } else {
    initialise(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
